<template>
  <div class="fgas-TopBlock">
    <slot name="grade-block" />
    <div class="fgas-IndicatorPanel">
      <slot name="indicator-panel" />
    </div>
    <slot name="status" />
  </div>
</template>

<script setup>
defineOptions({
  name: 'FormGradeAndStatusTopBlock'
})
</script>

<style lang="scss" scoped>
.fgas-TopBlock {
  display: grid;
  // gap: 8px;
  gap: 10px;
  // padding: 14px 18px 16px;
  padding: 18px;
  // background: $grey-3-next;
  // background-color: $white;
  --value-font-size: #{$fs-44};
  --suffix-font-size: #{$fs-24};
}

.fgas-IndicatorPanel {
  // margin: 0 0 4px 0;
}
</style>
